import { ParamIds, Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class BorderoKeys extends MainKeys {
    get place() {
        return Places.mcBordero
    }

    get filtroDataInicio() {
        const df = this._intent.getParameterAsString(ParamIds.mcBorderoFiltroDataInicial)
        return df ? new Date(df) : undefined
    }

    set filtroDataInicio(value: Date | undefined) {
        this._intent.setParameter(ParamIds.mcBorderoFiltroDataInicial, value?.toISOString())
    }

    get filtroDataFim() {
        const df = this._intent.getParameterAsString(ParamIds.mcBorderoFiltroDataFinal)
        return df ? new Date(df) : undefined
    }

    set filtroDataFim(value: Date | undefined) {
        this._intent.setParameter(ParamIds.mcBorderoFiltroDataFinal, value?.toISOString())
    }

    get filtroStatus() {
        return this._intent.getParameterAsString(ParamIds.mcBorderoFiltroStatus)
    }

    set filtroStatus(value: string | undefined) {
        this._intent.setParameter(ParamIds.mcBorderoFiltroStatus, value)
    }

    get filtroCdBordero() {
        return this._intent.getParameterAsString(ParamIds.mcBorderoFiltroCodBordero)
    }

    set filtroCdBordero(value: string | undefined) {
        this._intent.setParameter(ParamIds.mcBorderoFiltroCodBordero, value)
    }
}

export default BorderoKeys
